import platform from 'platform';
import Cookies from 'js-cookie';

const usersPotentialIpAddress = Cookies.get('remote-address') || 'Unknown';
const usersBrowserVersion = platform.version;
const usersBrowserName = platform.name;
const usersOperatingSystem = platform.os.family;

// https://jsben.ch/4iDft performance check
const getFullStoryUrl = () => ((typeof window.FS?.getCurrentSessionURL === 'function')
  ? window.FS.getCurrentSessionURL() || '' : '');

export default {
  usersPotentialIpAddress,
  usersBrowserVersion,
  usersBrowserName,
  usersOperatingSystem,
  getFullStoryUrl,
};
